export default "__VITE_ASSET__BpilIPQ3__"